import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import { Button } from '../Button/index.js';
import { Popover } from '../Popover/index.js';
import { DateRangePicker } from './DateRangePicker.js';
function defaultFormatDateRange(dateRange, intl) {
    if (!dateRange) {
        return intl.formatMessage({
            defaultMessage: 'Select a date range',
            id: 'bKPSni',
            description: 'Label to select a date range'
        });
    }
    return intl.formatMessage({
        defaultMessage: 'From {start, date, ::MMddyyyy} to {end, date, ::MMddyyyy}',
        id: '9BLmzs',
        description: 'Date range'
    }, { start: dateRange.start, end: dateRange.end });
}
/**
 * Select a date range.
 *
 * ### Import Guide
 *
 * ```jsx
 * import { DateRangePickerDialog } from "@panwds/react-ui";
 * ```
 */
export const DateRangePickerDialog = ({ button, dataMetrics, dataTestId, formatDateRange = defaultFormatDateRange, fullWidth = false, initialActiveDate, label, defaultPlacement = 'bottom-start', max, min, onApply, dateRange, showLabel, weekStartsOn, disabled = false, addClassName, addPopoverClassName }) => {
    const intl = useIntl();
    const [isOpen, setIsOpen] = useState(false);
    return (React.createElement(Popover, { dataMetrics: dataMetrics, dataTestId: dataTestId || 'date-range-picker-dialog', button: button || (React.createElement(Button, { fullWidth: fullWidth, isMenu: true, disabled: disabled }, formatDateRange(dateRange, intl))), defaultPlacement: defaultPlacement, label: label ??
            intl.formatMessage({
                defaultMessage: 'Search range',
                id: 'XSDZbV',
                description: 'Button label to enter a date range'
            }), showLabel: showLabel, isOpen: isOpen, onIsOpenChange: setIsOpen, addClassName: addClassName, addPopoverClassName: addPopoverClassName },
        React.createElement(DateRangePicker, { initialActiveDate: initialActiveDate, initialDateRange: dateRange, max: max, min: min, onApply: (nextDateRange) => {
                onApply(nextDateRange);
                setIsOpen(false);
            }, onCancel: () => setIsOpen(false), weekStartsOn: weekStartsOn, disabled: disabled })));
};
//# sourceMappingURL=DateRangePickerDialog.js.map